import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MemoryPhotoV1 } from '../MemoryPhotoV1';
import { MemoryRangeV1 } from '../MemoryRangeV1';
import { DEFAULT_CLARITY_VALUE } from '../../shared/memory-map-helpers';
import styles from './QuestionClaritySlideV1.css';

const MAX_VALUE = 100;
const BLUR_DIVIDER = 9;

function QuestionClaritySlideV1({ id, question, hint, imageId, ends, submitTemporaryAnswer, userResponse = {} }) {
    const [value, setValue] = useState(userResponse?.value ?? DEFAULT_CLARITY_VALUE);

    useEffect(() => {
        submitTemporaryAnswer({ id: 1, questionId: id, question, text: String(value), value });
    }, [value]);

    return (
        <div className={styles.form} key={id}>
            <div className={styles.text}>
                <h1 className={styles.question}>{question}</h1>
                <p className={styles.hint}>{hint}</p>
            </div>
            <div className={styles.slider}>
                <div className={styles.view}>
                    <div
                        className={styles.blur}
                        style={{ filter: `blur(${((MAX_VALUE - value) / BLUR_DIVIDER).toFixed(1)}px)` }}
                    >
                        <MemoryPhotoV1 imageId={imageId} radius='none' className={styles.photo} />
                    </div>
                </div>
                <MemoryRangeV1
                    value={value}
                    onChange={setValue}
                    label={question}
                    ends={ends}
                />
            </div>
        </div>
    );
}

QuestionClaritySlideV1.propTypes = {
    id: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    hint: PropTypes.string,
    imageId: PropTypes.string.isRequired,
    ends: PropTypes.arrayOf(PropTypes.string).isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object
};

export {
    QuestionClaritySlideV1
};
